import { z } from 'zod';

const RELATIONSHIPS = [
  'biological_mother',
  'biological_father',
  'partner',
  'caregiver',
  'grandparent',
  'other',
] as const;

export const relationshipSchema = z.enum(RELATIONSHIPS);

/** Canonical type — derived from the zod enum so adding a relationship
 *  needs only the const array change. */
export type Relationship = z.infer<typeof relationshipSchema>;

/** Display labels for each relationship plus the "Unspecified" sentinel
 *  used by edit UIs. Source of truth for both Family.tsx and MemberEditSheet. */
export const RELATIONSHIP_LABELS: Record<Relationship | 'none', string> = {
  none: 'Unspecified',
  biological_mother: 'Biological mother',
  biological_father: 'Biological father',
  partner: 'Partner',
  caregiver: 'Caregiver',
  grandparent: 'Grandparent',
  other: 'Other',
};

/** Patch one of the *current user's* own profile fields. */
export const mePatchSchema = z.object({
  name: z.string().min(1).max(40).optional(),
  /** Adult height in millimetres (300 cm hard cap). */
  height_mm: z.number().int().min(300).max(3000).nullable().optional(),
});

/** Patch a family member's profile. Owner can edit anyone; non-owners can
 *  only edit themselves. The API route enforces that. */
export const familyMemberPatchSchema = z.object({
  relationship: relationshipSchema.nullable().optional(),
  name: z.string().min(1).max(40).optional(),
  /** Adult height in millimetres (30–300 cm). */
  height_mm: z.number().int().min(300).max(3000).nullable().optional(),
});

export type RelationshipPatch = z.infer<typeof familyMemberPatchSchema>;
export type MePatch = z.infer<typeof mePatchSchema>;
export { RELATIONSHIPS };
